import React from 'react';


export default function UrlScanErrorListItem(props) {
    const { link, errorMessage } = props;
    return (
        <li className="list-group-item text-break">
            <div>
                <h6 className="card-subtitle" title={link.text}>
                    <small className="text-muted">{link.shortText}</small></h6>
                <h5 className="card-title" title={link.href}>
                    <small className="font-weight-bold">{errorMessage}</small>
                </h5>
            </div>
        </li>
    );
}